<template>
  <div
    class="Home"
    :style="`background-image: url('data/${bacInd + 1}bg.jpg');`"
  >
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img class="toInfo" dataHref="1" src="../assets/home/1.png" alt="" />
          <p>清象牙高浮雕<br />风景人物针线盒</p>
        </div>
        <div class="swiper-slide">
          <img class="toInfo" dataHref="2" src="../assets/home/2.png" alt="" />
          <p>清圆雕茜红鬼工球座<br />象牙国际象棋</p>
        </div>
        <div class="swiper-slide">
          <img class="toInfo" dataHref="3" src="../assets/home/3.png" alt="" />
          <p>清象牙镂雕花卉纹<br />开光亭塔山水帽章扇</p>
        </div>
        <div class="swiper-slide">
          <img class="toInfo" dataHref="4" src="../assets/home/4.png" alt="" />
          <p>清制茶图通草画</p>
        </div>
        <div class="swiper-slide">
          <img class="toInfo" dataHref="5" src="../assets/home/5.png" alt="" />
          <p>宋酱釉四系罐</p>
        </div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "./swiper.js";
export default {
  name: "Home",
  components: {},
  data() {
    //这里存放数据
    return {
      bacInd: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      let swiperDom = new Swiper(".swiper-container", {
        slidesPerView: 1.4,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange: () => {
            if (swiperDom) {
              let ind = swiperDom.realIndex;
              this.bacInd = ind;
            }
          },
        },
      });
      // 手动获取所有轮播dom，添加点击事件
      let domAll = document.querySelectorAll(".toInfo");
      domAll.forEach((v) => {
        let bs = v.getAttribute("dataHref");
        v.addEventListener("click", () => {
          this.$router.push(`Info${bs}`);
        });
      });
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
@import "./swiper.css";
.Home {
  background-color: #09465b;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  .swiper-container {
    width: 100%;
    height: 100%;
    .swiper-slide {
      height: 80%;
      position: relative;
      text-align: center;
      font-size: 18px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      transition: 300ms;
      transform: scale(0.8);
      img {
        width: 100%;
      }
      p {
        width: 100%;
        bottom: 0px;
        left: 0;
        position: absolute;
        font-size: 18px;
        line-height: 24px;
        color: #fff;
      }
    }
    .swiper-slide-active,
    .swiper-slide-duplicate-active {
      transform: scale(1);
    }
  }
  .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 50px;
  }
  /deep/.swiper-pagination-bullet {
    margin: 0 15px;
    width: 14px;
    height: 15px;
    opacity: 1;
    background: url("../assets/home/drop.png");
    background-size: 100% 100%;
  }
  /deep/.swiper-slide {
    pointer-events: none;
  }
  /deep/.swiper-slide-active {
    pointer-events: initial;
  }
  /deep/.swiper-pagination-bullet-active {
    background: url("../assets/home/dropAc.png");
    background-size: 100% 100%;
  }

}
</style>